import LegalLayout from "@/layouts/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service">
      <p>
        These Terms of Service (“Terms”) govern access to MinutePay, a software service for
        professional interpreters. By creating an account or using MinutePay, you agree to these Terms.
      </p>

      <h2>1. The MinutePay service</h2>
      <p>
        MinutePay is a productivity and income-tracking platform. It includes a web dashboard and a
        browser extension that can help you track interpreter calls, minutes, earnings, history,
        companies, goals, and related productivity information. MinutePay is a tracking and
        organization tool. It does not guarantee income, call volume, platform availability, or
        payment from interpreter companies.
      </p>

      <h2>2. Accounts</h2>
      <p>
        You must provide accurate account information and keep your password confidential. You are
        responsible for activity on your account. You must be able to form a contract and use the
        service only for lawful professional purposes. Notify MinutePay if you believe your account
        has been used without permission.
      </p>

      <h2>3. Subscription billing</h2>
      <p>
        Paid access to MinutePay Basic is offered as a recurring subscription of{" "}
        <strong>$9.99 USD per month</strong>, billed through Paddle. The subscription renews
        automatically each month until you cancel. Taxes or provider fees, if any, are determined
        by the payment provider and applicable law.
      </p>
      <p>
        MinutePay provides a <strong>7-day free trial</strong> through Paddle. Starting the trial
        requires a payment method. You are not charged today. After the trial, Paddle bills{" "}
        <strong>$9.99 USD per month</strong> unless you cancel before renewal. Completing checkout
        on the website does not itself change your license until Paddle confirms the subscription.
      </p>

      <h2>4. Cancellation</h2>
      <p>
        You may cancel a paid subscription to stop future renewals, using the billing tools in
        MinutePay and/or the payment provider’s customer portal where available. Cancellation stops
        future charges; it does not automatically refund a period that has already been billed. See
        the Refund Policy for how billing issues are handled.
      </p>

      <h2>5. Acceptable use</h2>
      <p>
        You may not misuse MinutePay, including by attempting to access other users’ data, disrupting
        the service, reverse engineering except where the law allows, using the service to violate
        others’ rights, or abusing payment or trial features. Tracking should be used only where you
        are allowed to record the relevant work activity.
      </p>

      <h2>6. Intellectual property</h2>
      <p>
        MinutePay, including its software, branding, and documentation, is owned by MinutePay and
        its licensors. You receive a limited, non-exclusive, non-transferable right to use the
        service while your account is in good standing. You keep rights in the work data you submit.
        MinutePay may use that data only to operate and improve the service as described in the
        Privacy Policy.
      </p>

      <h2>7. Availability and updates</h2>
      <p>
        We aim to keep MinutePay available, but we do not guarantee uninterrupted or error-free
        operation. Features, the website, the extension, and supported interpreter platforms may
        change. Call detection depends on the third-party sites you use and on your configuration.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, MinutePay is provided “as is.” We are not liable for
        lost income, missed calls, data loss, or indirect or consequential damages. Where liability
        cannot be excluded, it is limited to the amount you paid MinutePay for the service in the
        three months before the claim, or $9.99, whichever is greater, except where the law requires
        otherwise.
      </p>

      <h2>9. Termination and suspension</h2>
      <p>
        We may suspend or end access if you breach these Terms, misuse the service, or if a paid
        subscription is unpaid or canceled and you no longer have valid trial or other authorized
        access. You may stop using MinutePay at any time. Sections that should survive (including
        intellectual property and limitation of liability) remain in effect.
      </p>

      <h2>10. Contact</h2>
      <p>
        For account or billing questions, sign in to MinutePay and use Billing, or write from the
        email address on your account. MinutePay does not currently publish a separate public support
        inbox in this product.
      </p>
    </LegalLayout>
  );
}
